import PackageInfoCard from './packageInfoCard.container';
export default PackageInfoCard